import fetch from "cross-fetch";
import {
  ApolloProvider,
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink
} from "@apollo/client";

const DEFAULT_APOLLO_PROVIDER_OPTIONS = {
  graphqlEndpoint: ""
};

export const withApolloProvider = (
  WrappedComponent,
  { graphqlEndpoint } = DEFAULT_APOLLO_PROVIDER_OPTIONS
) => {
  const httpLink = new HttpLink({ uri: graphqlEndpoint, fetch });
  const cache = new InMemoryCache({
    addTypename: false
  });
  const client = new ApolloClient({
    link: ApolloLink.from([httpLink]),
    cache
  });
  return (props) => (
    <ApolloProvider client={client}>
      <WrappedComponent {...props} />
    </ApolloProvider>
  );
};
